import classE from "@/assets/images/reservation/berlin-e.png";
import classV from "@/assets/images/reservation/van-v.png";
import classS from "@/assets/images/reservation/berlin-s.png";
import classR from "@/assets/images/reservation/range-v.png";
import classSprinter from "@/assets/images/reservation/sprinter-vip.png";
import classSecurity from "@/assets/images/reservation/audi-a8-security.png";
import { COMPANY } from "@/config/company";

export const whatsappLink = `https://api.whatsapp.com/send/?phone=${COMPANY.whatsappIntl}&text=Bonjour%2C&type=phone_number&app_absent=0`;
export const contactEmail = COMPANY.email;
export const contactPhone = COMPANY.phoneDisplay;

export const instagramLink = "https://www.instagram.com/ksrentservices/";
export const xLink = "https://x.com/ksrentservices/";
export const pinterestLink = "https://fr.pinterest.com/ksrentservices/";
export const youtubeLink = "https://www.youtube.com/@Ksrentservices";

// Helper pour normaliser les clés de routes (bidirectionnel)
export const getRouteKey = (fromId: string, toId: string): string => {
  const sorted = [fromId, toId].sort();
  return `${sorted[0]}__${sorted[1]}`;
};

export type VehicleId =
  | "CLASS_E"
  | "CLASS_V"
  | "CLASS_S"
  | "CLASS_R"
  | "CLASS_SPRINTER"
  | "CLASS_SECURITY";

export type DisposalPackage = {
  hours: 3 | 4 | 8 | 10 | 12 | 14;
  price: number;
  extraHour: number;
};

export type Vehicle = {
  id: VehicleId;
  name: string;
  classLabel:
    | "Class E"
    | "Class V"
    | "Class S"
    | "Range"
    | "Sprinter VIP"
    | "Sécurité";
  image: any; // StaticImageData from Next.js
  maxPassengers: number;
  maxLuggage: number;
  pricePerKm: number;
  disposalPackages: DisposalPackage[];
  fixedTransfers: Record<string, number>;
};

export const VEHICLES: Record<VehicleId, Vehicle> = {
  CLASS_V: {
    id: "CLASS_V",
    name: "Class V",
    classLabel: "Class V",
    image: classV,
    maxPassengers: 7,
    maxLuggage: 5,
    pricePerKm: 3.1,
    disposalPackages: [
      { hours: 3, price: 360, extraHour: 120 },
      { hours: 4, price: 480, extraHour: 120 },
      { hours: 8, price: 880, extraHour: 120 },
      { hours: 10, price: 1000, extraHour: 120 },
      { hours: 12, price: 1100, extraHour: 110 },
      { hours: 14, price: 1260, extraHour: 110 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 130,
      MONACO__NCE_AIRPORT: 200,
      NCE_AIRPORT__SAINT_TROPEZ: 400,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 200,
      MONACO__SAINT_TROPEZ: 600,
      CANNES__MONACO: 250,
      CANNES__SAINT_TROPEZ: 350,
    },
  },
  CLASS_S: {
    id: "CLASS_S",
    name: "Class S",
    classLabel: "Class S",
    image: classS,
    maxPassengers: 3,
    maxLuggage: 3,
    pricePerKm: 3.6,
    disposalPackages: [
      { hours: 3, price: 450, extraHour: 150 },
      { hours: 4, price: 600, extraHour: 150 },
      { hours: 8, price: 1100, extraHour: 150 },
      { hours: 10, price: 1250, extraHour: 150 },
      { hours: 12, price: 1350, extraHour: 130 },
      { hours: 14, price: 1540, extraHour: 130 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 150,
      MONACO__NCE_AIRPORT: 250,
      NCE_AIRPORT__SAINT_TROPEZ: 550,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 250,
      MONACO__SAINT_TROPEZ: 800,
      CANNES__MONACO: 300,
      CANNES__SAINT_TROPEZ: 500,
    },
  },
  CLASS_E: {
    id: "CLASS_E",
    name: "Class E",
    classLabel: "Class E",
    image: classE,
    maxPassengers: 3,
    maxLuggage: 3,
    pricePerKm: 2.6,
    disposalPackages: [
      { hours: 3, price: 240, extraHour: 80 },
      { hours: 4, price: 320, extraHour: 80 },
      { hours: 8, price: 600, extraHour: 80 },
      { hours: 10, price: 750, extraHour: 80 },
      { hours: 12, price: 900, extraHour: 80 },
      { hours: 14, price: 1000, extraHour: 80 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 100,
      MONACO__NCE_AIRPORT: 150,
      NCE_AIRPORT__SAINT_TROPEZ: 300,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 150,
      MONACO__SAINT_TROPEZ: 450,
      CANNES__MONACO: 200,
      CANNES__SAINT_TROPEZ: 250,
    },
  },
  CLASS_R: {
    id: "CLASS_R",
    name: "Range",
    classLabel: "Range",
    image: classR,
    maxPassengers: 3,
    maxLuggage: 3,
    pricePerKm: 4.0,
    disposalPackages: [
      { hours: 3, price: 450, extraHour: 150 },
      { hours: 4, price: 600, extraHour: 150 },
      { hours: 8, price: 1100, extraHour: 150 },
      { hours: 10, price: 1250, extraHour: 150 },
      { hours: 12, price: 1350, extraHour: 130 },
      { hours: 14, price: 1540, extraHour: 130 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 150,
      MONACO__NCE_AIRPORT: 250,
      NCE_AIRPORT__SAINT_TROPEZ: 550,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 250,
      MONACO__SAINT_TROPEZ: 800,
      CANNES__MONACO: 300,
      CANNES__SAINT_TROPEZ: 500,
    },
  },
  // Sprinter VIP — minibus grand groupe (transferts événements, équipes,
  // familles). Tarifs alignés sur la Classe S (choix métier).
  CLASS_SPRINTER: {
    id: "CLASS_SPRINTER",
    name: "Sprinter VIP",
    classLabel: "Sprinter VIP",
    image: classSprinter,
    maxPassengers: 16,
    maxLuggage: 14,
    pricePerKm: 3.6,
    disposalPackages: [
      { hours: 3, price: 450, extraHour: 150 },
      { hours: 4, price: 600, extraHour: 150 },
      { hours: 8, price: 1100, extraHour: 150 },
      { hours: 10, price: 1250, extraHour: 150 },
      { hours: 12, price: 1350, extraHour: 130 },
      { hours: 14, price: 1540, extraHour: 130 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 150,
      MONACO__NCE_AIRPORT: 250,
      NCE_AIRPORT__SAINT_TROPEZ: 550,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 250,
      MONACO__SAINT_TROPEZ: 800,
      CANNES__MONACO: 300,
      CANNES__SAINT_TROPEZ: 500,
    },
  },
  // Véhicule blindé (sécurité) — Audi A8 L Security / Mercedes S680 Guard.
  // 5,00 €/km ; forfaits trajets + mise-à-dispo proportionnels (≈ ×1,25 de la
  // classe haute).
  CLASS_SECURITY: {
    id: "CLASS_SECURITY",
    name: "Véhicule blindé",
    classLabel: "Sécurité",
    image: classSecurity,
    maxPassengers: 3,
    maxLuggage: 3,
    pricePerKm: 5.0,
    disposalPackages: [
      { hours: 3, price: 560, extraHour: 190 },
      { hours: 4, price: 750, extraHour: 190 },
      { hours: 8, price: 1380, extraHour: 190 },
      { hours: 10, price: 1560, extraHour: 190 },
      { hours: 12, price: 1690, extraHour: 160 },
      { hours: 14, price: 1930, extraHour: 160 },
    ],
    fixedTransfers: {
      CANNES__NCE_AIRPORT: 190,
      MONACO__NCE_AIRPORT: 315,
      NCE_AIRPORT__SAINT_TROPEZ: 690,
      NCE_AIRPORT__ST_JEAN_CAP_FERRAT: 315,
      MONACO__SAINT_TROPEZ: 1000,
      CANNES__MONACO: 375,
      CANNES__SAINT_TROPEZ: 625,
    },
  },
};

// Zones tarifaires (géofencing léger)
export type PricingZone = {
  id: string;
  center: { lat: number; lon: number };
  radiusKm: number;
};

export const PRICING_ZONES: PricingZone[] = [
  {
    id: "CANNES",
    center: { lat: 43.553876, lon: 7.019303 }, // Gare de Cannes
    radiusKm: 10,
  },
  {
    id: "NCE_AIRPORT",
    center: { lat: 43.6584015, lon: 7.2158699 }, // Nice Côte d'Azur
    radiusKm: 6,
  },
];

const toRad = (value: number) => (value * Math.PI) / 180;

const haversineDistanceKm = (
  a: { lat: number; lon: number },
  b: { lat: number; lon: number },
): number => {
  const R = 6371;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  return R * c;
};

export const resolvePricingZone = (place: {
  pricingZoneId?: string | null;
  coordinates?: { lat: number; lon: number } | null;
}): string | null => {
  if (place.pricingZoneId) return place.pricingZoneId;
  if (place.coordinates) {
    const zone = PRICING_ZONES.find(
      (z) => haversineDistanceKm(place.coordinates!, z.center) <= z.radiusKm,
    );
    return zone?.id ?? null;
  }
  return null;
};

export const info = {
  // Tarifs de base
  tarifKilometrique: "2,50 €/Km",
  tarifHoraire: "50€/h",

  // Tarifs spécifiques pour Bordeaux
  tarifBordeauxBase: "35€",
  tarifBordeauxDistance: "2,50 €/Km",
  distanceBordeauxMax: 10, // km

  // Tarifs spécifiques pour la couronne de Bordeaux
  tarifCouronneBase: "50€",
  tarifCouronneDistance: "2,50 €/Km",

  // Points d'intérêt importants
  gareSaintJean: "Gare de Bordeaux-Saint-Jean",
  aeroportBordeaux: "Aéroport de Bordeaux-Mérignac",

  // Limites géographiques
  bordeauxCentre: "Bordeaux Centre",
  bordeauxCouronne: "Bordeaux Couronne",
};

export const vtc = {
  chauffeur: COMPANY.legal.director,
  vehicule: "Mercedes Classe V",
  immatriculation: "Sur demande",
  modele: "Van premium",
  registreVTC: COMPANY.legal.vtcLicense,
  siren: COMPANY.legal.siren,
  entreprise: COMPANY.brand,
  mailPro: COMPANY.email,
  telPro: COMPANY.phoneIntl,
  TVA: "10%",
  modePaiement: "Paiement à bord",
  prefixe: "KSR",
  // Informations bancaires
  banque: {
    titulaire: COMPANY.brand,
    adresse: COMPANY.legal.addressLine1,
    codePostal: COMPANY.legal.postalCode,
    ville: COMPANY.legal.city,
    banque: {
      nom: "Qonto",
      adresse: "18 rue de Navarin",
      codePostal: "75009",
      ville: "Paris",
      pays: "France",
      codeBanque: "16958",
      codeAgence: "00001",
      numeroCompte: "",
      cleRIB: "",
      IBAN: "",
      BIC: "",
      BICPartenaire: "",
    },
  },
};
